export const metaux = [
    {
      value: 'or_750',
      type: 'single',
      label: 'Or 750 (18 carats)',
      coef: 0.75,
      is_or: true,
    },
    {
      value: 'or_575',
      type: 'single',
      label: 'Or 575 (14 carats)',
      coef: 0.575,
      is_or: true,
    },
    {
      value: 'or_375',
      type: 'single',
      label: 'Or 375 (9 carats)',
      coef: 0.375,
      is_or: true,
    },
    {
      value: 'argent_925',
      type: 'single',
      label: 'Argent 925',
      coef: 1,
      is_or: false,
    },
    {
      value: 'platine_950',
      type: 'single',
      label: 'Platine 950',
      coef: 1,
      is_or: false,
    },
    {
      value: 'palladium_950',
      type: 'single',
      label: 'Palladium 950',
      coef: 1,
      is_or: false,
    },
    {
      value: 'or_blanc_palladié',
      type: 'compose',
      label: 'Or blanc palladié',
      is_or: false,
      coef: 1,
      composition: [
        {
          label: 'Or',
          value: 'or',
          coef: 0.75,
        },
        {
          label: 'Palladium',
          value: 'palladium',
          coef: 0.13,
        },
      ],
    },
  ];

 export const cours_metaux_default = [
  {
    value : 'or',
    nom : 'Or',
    prix_gr : 0.00,
    prix_kg : 0.00,
  },
  {
    value : 'argent',
    nom : 'Argent',
    prix_gr : 0.00,
    prix_kg : 0.00,
  },
  {
    value : 'platine',
    nom : 'Platine',
    prix_gr : 0.00,
    prix_kg : 0.00,
  },
  {
    value : 'palladium',
    nom : 'Palladium',
    prix_gr : 0.00,
    prix_kg : 0.00,
  },
 ]